// extracted by mini-css-extract-plugin
export default {"base":"ActionHidden_base__jUlRq"};